import { Link } from "react-router-dom";
import { ArrowRight, Newspaper } from "lucide-react";
import { useSite, usePublic } from "../../lib/site";
import { fmtDate } from "../../lib/i18n";
import { Img } from "./Common";
import { Loading } from "../../pages/site/NotFound";

export const pressHref = (lang, slug) => `${lang === "tr" ? "" : "/" + lang}/basin-arsivi${slug ? "/" + slug : ""}`;

export function PressCard({ p }) {
  const { lang, t } = useSite();
  return (
    <Link to={pressHref(lang, p.slug)} data-testid={`press-card-${p.slug}`} className="group flex flex-col rounded-[var(--s-radius-sm)] overflow-hidden border border-site-border bg-[color:var(--s-surface,transparent)] hover:border-s-primary transition-colors duration-300">
      <div className="aspect-[16/10] overflow-hidden bg-s-border relative">
        {p.cover ? (
          <Img src={p.cover} alt={t(p.title)} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
        ) : (
          <div className="w-full h-full relative overflow-hidden bg-gradient-to-br from-s-primary/5 via-transparent to-s-primary/10">
            <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(circle at 25% 20%, currentColor 1px, transparent 1px), radial-gradient(circle at 70% 70%, currentColor 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
            <div className="relative w-full h-full flex flex-col items-center justify-center gap-2.5 text-s-muted px-4">
              <Newspaper size={34} strokeWidth={1.3} className="text-s-primary/70" />
              {p.source_name && <span className="text-[11px] uppercase tracking-[0.22em] font-semibold text-center">{p.source_name}</span>}
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-col flex-1 p-5">
        <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-s-muted mb-3">
          {p.source_name && <span className="inline-flex items-center gap-1 font-semibold text-s-primary"><Newspaper size={12} />{p.source_name}</span>}
          {p.source_name && <span className="opacity-40">•</span>}
          <span>{fmtDate(p.published_at, lang)}</span>
        </div>
        <h3 className="font-heading text-xl font-semibold leading-snug group-hover:text-s-primary transition-colors">{t(p.title)}</h3>
        {t(p.summary) && <p className="mt-3 text-sm text-s-muted line-clamp-3">{t(p.summary)}</p>}
        <span className="mt-4 pt-3 inline-flex items-center gap-1.5 text-sm font-medium text-s-primary">
          {lang === "tr" ? "Haberi oku" : "Read"} <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
        </span>
      </div>
    </Link>
  );
}

export function PressGrid() {
  const { ui } = useSite();
  const { data = [], isLoading } = usePublic(["press"], "/public/press");
  if (isLoading) {
    return <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-8"><Loading /></div>;
  }
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-6 pb-8" data-testid="press-grid">
      {data.length === 0 ? (
        <p className="text-s-muted py-16 text-center" data-testid="press-empty">{ui.noResults}</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {data.map((p) => <PressCard key={p.id} p={p} />)}
        </div>
      )}
    </section>
  );
}
